import { useQuery } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { Alert, Button, Result } from 'antd'
import { useTRPC } from '@/trpc/react.ts'

export function CustomerSendResult({
  customerId,
  deliveryId,
  groupIds,
  initialStatus,
  open
}: {
  customerId: number
  deliveryId: number
  groupIds: number[]
  initialStatus: string
  open: boolean
}) {
  const trpc = useTRPC(),
    router = useRouter()
  const status = useQuery({
    ...trpc.bill.customerSendStatus.queryOptions({ customerId, deliveryId }),
    enabled: open,
    refetchInterval: (query) => (['pending', 'sending'].includes(query.state.data?.status ?? 'pending') ? 2000 : false)
  })
  const deliveryStatus = status.data?.status ?? initialStatus
  let title = '已生成账单组，等待网关发送'
  let description = '发送任务已保存，客服网关将 PDF 发到已绑定企微群。'
  let resultStatus: 'success' | 'info' | 'warning' | 'error' = 'info'
  if (deliveryStatus === 'sending') {
    title = '正在发送 PDF'
    description = '客服网关已领取任务，正在上传并发送 PDF。'
  }
  if (deliveryStatus === 'accepted') {
    title = '企微已接受 PDF'
    description = '平台已返回成功回执，请在对应群中核对附件。'
    resultStatus = 'success'
  }
  if (deliveryStatus === 'unknown') {
    title = '发送结果未知'
    description = '请先核对群内消息，避免重复发送。'
    resultStatus = 'warning'
  }
  if (deliveryStatus === 'failed') {
    title = '发送失败'
    description = status.data?.error ?? '请检查机器人、客户群绑定和账单组状态。'
    resultStatus = 'error'
  }
  return (
    <div role="status" aria-live="polite">
      <Result
        status={resultStatus}
        title={title}
        subTitle={description}
        extra={
          <Button
            href={router.buildLocation({ to: '/finance/receipts', search: { ids: groupIds } }).href}
            target="_blank"
            rel="noopener noreferrer"
          >
            查看账单组 PDF
          </Button>
        }
      />
      {status.isError && (
        <Alert
          type="warning"
          showIcon
          title="发送任务已提交，暂时无法查询回执"
          action={<Button onClick={() => void status.refetch()}>刷新结果</Button>}
        />
      )}
    </div>
  )
}
